import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { CalendarEvent } from '../../utils/CalendarEvent';
import { Calendar } from '../../utils/Calendar';
import { Subject } from 'rxjs/Subject';
import { CalendarUtilsService } from './../../utils/calendar-utils.service';
export class ScheduleViewComponent implements OnInit, OnChanges {
/**
 * An array of events to display on view.
 */
events: CalendarEvent[] = [];
/**
 * An array of events to display on view.
 */
calendars: Calendar[] = [];
/**
 * The current view date
 */
viewDate: Date;
/**
 * An observable that when emitted on will re-render the current view
 */
refresh: Subject<any>;
/**
 * Called when the event title is clicked
 */
eventClicked: EventEmitter<{ event: CalendarEvent }> = new EventEmitter<{
    event: CalendarEvent;
  }>();
public view: any[];
/**
 * @param {?} utils
 */
constructor(private utils: CalendarUtilsService) { }
/**
 * @return {?}
 */
ngOnInit() {
  }
/**
 * @param {?} changes
 * @return {?}
 */
ngOnChanges(changes: any): void {
    if (
      changes.viewDate ||
      changes.calendars ||
      changes.events
    ) {
      this.refreshBody();
    }
  }
/**
 * @return {?}
 */
private refreshBody(): void {
    this.view = this.utils.getScheduleView({
      events: this.events,
      calendars: this.calendars,
      viewDate: this.viewDate,
    });
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-schedule-view',
  template: `
    <div class="cal-schedule-view">
      <div class="cal-schedule-day" *ngFor="let day of view">
          <div class="cal-schedule-event-date">
              <div class="cal-schedule-event-date-day">{{ day.date | date:'EEE' }}</div>
              <div class="cal-schedule-event-date-month">{{ day.date | date:'MMM d' }}</div>
          </div>
          <div class="cal-schedule-events">
            <div *ngFor="let event of day.events" (click)="eventClicked.emit({event:event})" class="cal-schedule-event row">
                <div class="col-lg-4 cal-schedule-event-header">
                    <div 
                        [style.backgroundColor]="event.color ? event.color : event.calendar.color"
                        class="cal-schedule-event-color mr-2">
                    </div>
                    <div class="cal-schedule-event-time" *ngIf="!event.allDay">
                        {{ event.start | date:'hh:mm a' }} - {{ event.end | date:'hh:mm a' }}
                    </div>
                    <div class="cal-schedule-event-time" *ngIf="event.allDay">
                        All day
                    </div>
                </div>
                <div class="cal-schedule-event-title col-lg-8">
                    {{ event.title }}
                </div>
            </div>
          </div>
      </div>
    </div>
  `,
  styles: [`
    .cal-schedule-view {
      border-left: 1px solid #EBEEF2;
      border-top: 1px solid #EBEEF2;
      border-right: 1px solid #EBEEF2;
      background-color: white; }

    .cal-schedule-day {
      border-bottom: 1px solid #EBEEF2;
      padding-top: 10px;
      padding-bottom: 10px;
      color: #555555;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex; }

    .cal-schedule-events {
      -webkit-box-flex: 1;
          -ms-flex: 1;
              flex: 1; }

    .cal-schedule-event {
      color: #555555;
      padding: 5px; }

    .cal-schedule-event:hover {
      background-color: #f2f2f2;
      cursor: pointer; }

    .cal-schedule-event-header {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex; }

    .cal-schedule-event-date {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
          -ms-flex-direction: column;
              flex-direction: column;
      font-size: 12px;
      color: #555555;
      padding-left: 25px;
      min-width: 80px; }

    .cal-schedule-event-title {
      font-size: 14px;
      -webkit-box-flex: 1;
          -ms-flex: 1;
              flex: 1;
      color: #555555; }

    .cal-schedule-event-time {
      font-size: 12px;
      font-weight: normal;
      min-width: 130px;
      -webkit-box-align: center;
          -ms-flex-align: center;
              align-items: center;
      color: #555555; }

    .cal-schedule-event-color {
      height: 10px !important;
      width: 10px !important;
      border-radius: 50%; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: CalendarUtilsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'events': [{ type: Input },],
'calendars': [{ type: Input },],
'viewDate': [{ type: Input },],
'refresh': [{ type: Input },],
'eventClicked': [{ type: Output },],
};
}

function ScheduleViewComponent_tsickle_Closure_declarations() {
/** @type {?} */
ScheduleViewComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ScheduleViewComponent.ctorParameters;
/** @type {?} */
ScheduleViewComponent.propDecorators;
/**
 * An array of events to display on view.
 * @type {?}
 */
ScheduleViewComponent.prototype.events;
/**
 * An array of events to display on view.
 * @type {?}
 */
ScheduleViewComponent.prototype.calendars;
/**
 * The current view date
 * @type {?}
 */
ScheduleViewComponent.prototype.viewDate;
/**
 * An observable that when emitted on will re-render the current view
 * @type {?}
 */
ScheduleViewComponent.prototype.refresh;
/**
 * Called when the event title is clicked
 * @type {?}
 */
ScheduleViewComponent.prototype.eventClicked;
/** @type {?} */
ScheduleViewComponent.prototype.view;
/** @type {?} */
ScheduleViewComponent.prototype.utils;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
